import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import LoadingOverlay from '../../../common/LoadingOverlay';
import { useTranslation } from 'react-i18next';

function BillingDetailsForm(props) {
    const { t } = useTranslation();
    const { loading, values, errors, touched, handleInputChange, partnerLoading } = props;

    function _hasErrors(key) {
        if(!errors || !touched) {
            return false;
        }
        return errors[key] && touched[key];
    }

    return (
        <div style={{ position: 'relative' }}>
            <Form.Group as={Row} controlId="billingDetails['invoiceCompany']" className="required">
                <Form.Label column sm={3}>{t('general.company')}</Form.Label>
                <Col sm={9}>
                    <Form.Control
                        onChange={handleInputChange}
                        value={values.invoiceCompany}
                        disabled={loading}
                        isInvalid={_hasErrors('invoiceCompany')}
                    />
                    {_hasErrors('invoiceCompany') ? (
                        <Form.Control.Feedback type="invalid">
                            {errors.invoiceCompany}
                        </Form.Control.Feedback>
                    ) : null}
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="billingDetails['invoiceCompanyBusinessID']" className="required">
                <Form.Label column sm={3}>{t('general.business_id')}</Form.Label>
                <Col sm={4}>
                    <Form.Control
                        onChange={handleInputChange}
                        value={values.invoiceCompanyBusinessID}
                        disabled={loading}
                        isInvalid={_hasErrors('invoiceCompanyBusinessID')}
                    />
                    {_hasErrors('invoiceCompanyBusinessID') ? (
                        <Form.Control.Feedback type="invalid">
                            {errors.invoiceCompanyBusinessID}
                        </Form.Control.Feedback>
                    ) : null}
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="billingDetails['invoiceStreetAddress']">
                <Form.Label column sm={3}>{t('general.street_address')}</Form.Label>
                <Col sm={9}>
                    <Form.Control
                        onChange={handleInputChange}
                        value={values.invoiceStreetAddress || ''}
                        disabled={loading}
                    />
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="billingDetails['invoicePostalCode']">
                <Form.Label column sm={3}>{t('general.postal_code')}</Form.Label>
                <Col sm={3}>
                    <Form.Control
                        onChange={handleInputChange}
                        value={values.invoicePostalCode || ''}
                        disabled={loading}
                    />
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="billingDetails['invoiceCity']">
                <Form.Label column sm={3}>{t('general.city')}</Form.Label>
                <Col sm={6}>
                    <Form.Control
                        onChange={handleInputChange}
                        value={values.invoiceCity || ''}
                        disabled={loading}
                    />
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="billingDetails['invoiceReference']">
                <Form.Label column sm={3}>{t('general.invoice_reference')}</Form.Label>
                <Col sm={6}>
                    <Form.Control
                        onChange={handleInputChange}
                        value={values.invoiceReference || ''}
                        disabled={loading}
                    />
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="billingDetails['eInvoiceAddress']">
                <Form.Label column sm={3}>{t('general.einvoice_address')}</Form.Label>
                <Col sm={6}>
                    <Form.Control
                        onChange={handleInputChange}
                        value={values.eInvoiceAddress || ''}
                        disabled={loading}
                    />
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="billingDetails['eInvoiceIntermediateId']">
                <Form.Label column sm={3}>{t('general.einvoice_intermediate_id')}</Form.Label>
                <Col sm={6}>
                    <Form.Control
                        onChange={handleInputChange}
                        value={values.eInvoiceIntermediateId || ''}
                        disabled={loading}
                    />
                </Col>
            </Form.Group>
            {partnerLoading ? <LoadingOverlay /> : null}
        </div>
    )
}

export default BillingDetailsForm;